<template>
  <base-wrapper
    :loading="
      loadingHistories ||
      loadingBonus ||
      loadingSaveHistory ||
      loadingResetTaken ||
      downloadHistoryModal.loading
    "
  >
    <div class="space-y-4">
      <base-card title="Ambil Data Bonus">
        <div class="space-y-4">
          <div class="grid grid-cols-4 gap-4">
            <mitra-period-select
              class="col-span-4"
              grid
              inset
              with-label
              prev-period
              v-model="form.mitraPeriodId"
            />
            <base-input
              inset
              label="Total Bonus"
              type="text"
              currency
              placeholder="Masukkan total bonus"
              v-model="form.expectedTotalBonus"
            />
            <base-input
              inset
              label="Total Bonus Nuera"
              type="text"
              currency
              placeholder="Masukkan total bonus"
              v-model="form.expectedTotalBonusNuera"
            />
            <base-input
              inset
              label="Jumlah Mitra Tupo"
              type="text"
              currency
              placeholder="Masukkan total bonus"
              v-model="form.expectedTotalOfficePoint"
            />
            <base-input
              inset
              label="Jumlah Mitra Tupo Nuera"
              type="text"
              currency
              placeholder="Masukkan total bonus"
              v-model="form.expectedTotalOfficeNueraPoint"
            />
          </div>
          <base-button
            :disabled="
              !form.expectedTotalBonus ||
              !form.expectedTotalBonusNuera ||
              !form.expectedTotalOfficePoint ||
              !form.expectedTotalOfficeNueraPoint ||
              !form.mitraPeriodId
            "
            :loading="loadingSync.visible"
            @click="onSync"
            >{{
              loadingSync.visible ? getStatusText(loadingSync.text) : 'Ambil Data Bonus'
            }}</base-button
          >
        </div>
      </base-card>
      <base-card title="Riwayat Ambil Data Bonus">
        <datatable
          :columns="historyColumns"
          :total="histories.meta.page.total"
          :perPage="histories.meta.page.perPage"
          :currentPage="histories.meta.page.currentPage"
          :meta="histories.meta"
          @pagechanged="onHistoryPageChange"
        >
          <template v-slot:tbody="{ classes }">
            <tr
              v-for="history in histories.data"
              :key="history.id"
              :class="[classes.tr, 'bg-white hover:bg-green-100']"
            >
              <td :class="[classes.td]">
                {{ history.attributes.createdAt | formatDate }}
              </td>
              <td :class="[classes.td]">
                {{ history.attributes.period_name ?? '-' }}
              </td>
              <td :class="[classes.td]">
                {{ history.attributes.user }}
              </td>
              <td :class="[classes.td]">
                {{ history.attributes.expected_total_bonus | toCurrency }} /
                {{ history.attributes.total_bonus | toCurrency }}
              </td>
              <td :class="[classes.td]">
                {{ history.attributes.expected_total_bonus_nuera | toCurrency }}
                / {{ history.attributes.total_bonus_nuera | toCurrency }}
              </td>
              <td :class="[classes.td]">
                {{
                  history.attributes.expected_total_office_point | toCurrency
                }}
                / {{ history.attributes.total_office_point | toCurrency }}
              </td>
              <td :class="[classes.td]">
                {{
                  history.attributes.expected_total_office_nuera_point
                    | toCurrency
                }}
                / {{ history.attributes.total_office_nuera_point | toCurrency }}
              </td>
              <td :class="[classes.td]">
                {{ history.attributes.finishedAt | formatDate }}
              </td>
              <td
                :class="[classes.td, 'text-center']"
                :title="
                  history.attributes.status === 'success' &&
                  checkHistoryNumberInValid(history)
                    ? 'Input total bonus tidak sesuai dengan total bonus'
                    : ''
                "
              >
                <Icon
                  v-if="history.attributes.status !== 'success'"
                  icon="heroicons:clock-solid"
                  class="mx-auto h-5 w-5 text-yellow-600"
                />
                <Icon
                  v-else-if="checkHistoryNumberInValid(history)"
                  icon="heroicons:exclamation-triangle-solid"
                  class="mx-auto h-5 w-5 text-red-600"
                />
                <Icon
                  v-else
                  icon="heroicons:check-circle-solid"
                  class="mx-auto h-5 w-5 text-green-600"
                />
              </td>
              <td :class="[classes.td]" :title="history.attributes.error_message">
                <div class="flex justify-center gap-2">
                  <base-badge
                    :color="getStatusColor(history.attributes.status)"
                    >{{ getStatusText(history.attributes.status) }}</base-badge
                  >
                  <base-button
                    size="sm"
                    color="white"
                    @click="onEditHistory(history)"
                  >
                    <Icon
                      class="h-4 w-4"
                      icon="heroicons:pencil-square-solid"
                    />
                  </base-button>
                </div>
              </td>
              <td :class="[classes.td, 'text-center']">
                <div class="flex justify-center gap-2">
                  <base-badge
                    :color="history.attributes.takenAt ? 'green' : 'yellow'"
                    >{{
                      history.attributes.takenAt ? 'Diambil' : 'Belum Diambil'
                    }}</base-badge
                  >
                  <base-button
                    v-if="history.attributes.takenAt"
                    size="sm"
                    color="white"
                    @click="onResetTakenHistory(history)"
                  >
                    <Icon class="h-4 w-4" icon="heroicons:arrow-path" />
                  </base-button>
                </div>
              </td>
            </tr>
          </template>
        </datatable>
      </base-card>
      <base-card title="Data Bonus">
        <template #action>
          <div class="flex items-center gap-2">
            <base-input
              type="search"
              :shadow="false"
              placeholder="Cari Kode Kantor"
              v-model="filterBonus.office"
              debounce
              @native-input="loadBonus"
            />
            <base-input
              type="search"
              :shadow="false"
              placeholder="Cari Kode TMPBNS"
              v-model="filterBonus.bonus_office"
              debounce
              @native-input="loadBonus"
            />
            <base-select
              :shadow="false"
              :expand="false"
              :options="[
                { key: 'all', value: null, label: 'Pilih Keterangan' },
                { key: 'stockist', value: 'stockist', label: 'Stockist' },
                { key: 'transfer', value: 'transfer', label: 'Transfer' },
                { key: 'pending', value: 'pending', label: 'Pending' },
                { key: 'empty', value: '', label: 'Kosong' },
              ]"
              v-model="filterBonus.keterangan"
              @change="loadBonus"
            />
            <base-select
              :shadow="false"
              :expand="false"
              :options="[
                { key: 'all', value: null, label: 'Status' },
                {
                  key: 'belum_diambil',
                  value: 'not-taken',
                  label: 'Belum Diambil',
                },
                { key: 'diambil', value: 'taken', label: 'Diambil' },
                {
                  key: 'belum_diterima',
                  value: 'not-retrieved',
                  label: 'Belum Diterima',
                },
                { key: 'diterima', value: 'retrieved', label: 'Diterima' },
              ]"
              v-model="filterBonus.status"
              @change="loadBonus"
            />
            <mitra-period-select
              prev-period
              v-model="filterBonus.mitra_period_id"
              @change="loadBonus"
            />
            <base-button :loading="loadingDownload.visible" @click="onDownload">
              <p v-if="loadingDownload.visible">{{ loadingDownload.text }}</p>
              <template v-else>
                <Icon icon="heroicons:arrow-down-tray" class="h-4 w-4" />
                Download
              </template>
            </base-button>
            <base-button color="white" @click="onOpenDownloadHistory">
              <Icon icon="heroicons:queue-list" class="h-4 w-4" />
              Riwayat Download
            </base-button>
          </div>
        </template>

        <datatable
          :columns="bonusColumns"
          :scroll-x="false"
          :total="bonus.meta.count"
          :perPage="bonus.meta.page.perPage"
          :currentPage="bonus.meta.page.currentPage"
          :meta="bonus.meta"
          :sort="sortBonus"
          cursor
          @pagechanged="onBonusPageChange"
          @sortchanged="onBonusSortChange"
        >
          <template v-slot:tbody="{ classes }">
            <tr
              v-for="bonusItem in bonus.data"
              :key="bonusItem.id"
              :class="[classes.tr, 'bg-white hover:bg-green-100']"
            >
              <td :class="[classes.td]">
                <strong class="text-gray-900">{{
                  bonusItem.attributes.code
                }}</strong>
              </td>
              <td :class="[classes.td]">
                {{ bonusItem.attributes.temp_code }}
              </td>
              <td :class="[classes.td]">
                {{ bonusItem.attributes.name }}
              </td>
              <td :class="[classes.td]">
                {{ bonusItem.attributes.bonus_office }}
              </td>
              <td :class="[classes.td, 'text-right']">
                {{ bonusItem.attributes.rabat | toCurrency }}
              </td>
              <td :class="[classes.td]">
                {{ bonusItem.attributes.keterangan || '-' }}
              </td>
              <td :class="[classes.td, 'text-center']">
                <base-badge
                  :color="bonusItem.attributes.taken_at ? 'green' : 'yellow'"
                  >{{
                    bonusItem.attributes.taken_at ? 'Diambil' : 'Belum Diambil'
                  }}</base-badge
                >
              </td>
              <td :class="[classes.td, 'text-center']">
                <base-badge
                  :color="
                    bonusItem.attributes.retrieved_at ? 'green' : 'yellow'
                  "
                  >{{
                    bonusItem.attributes.retrieved_at
                      ? 'Diterima'
                      : 'Belum Diterima'
                  }}</base-badge
                >
              </td>
            </tr>
            <tr v-if="bonus.data.length" :class="classes.tr">
              <td :class="[classes.td, 'text-right']" colspan="5">
                {{ bonus.meta.total | toCurrency }}
              </td>
            </tr>
          </template>
        </datatable>
      </base-card>
    </div>

    <base-modal
      :showing="editHistoryModal.visible"
      @close="editHistoryModal.visible = false"
    >
      <base-card title="Edit Riwayat Ambil Bonus" :with-style="false">
        <form class="space-y-4" @submit.prevent="onSaveEditHistory">
          <base-input
            inset
            label="Total Bonus"
            type="text"
            currency
            placeholder="Masukkan total bonus"
            v-model="editHistoryModal.form.expectedTotalBonus"
          />
          <base-input
            inset
            label="Total Bonus Nuera"
            type="text"
            currency
            placeholder="Masukkan total bonus"
            v-model="editHistoryModal.form.expectedTotalBonusNuera"
          />
          <base-input
            inset
            label="Jumlah Mitra Tupo"
            type="text"
            currency
            placeholder="Masukkan total bonus"
            v-model="editHistoryModal.form.expectedTotalOfficePoint"
          />
          <base-input
            inset
            label="Jumlah Mitra Tupo Nuera"
            type="text"
            currency
            placeholder="Masukkan total bonus"
            v-model="editHistoryModal.form.expectedTotalOfficeNueraPoint"
          />
          <div class="flex gap-2">
            <base-button>Simpan</base-button>
            <base-button color="white" @click="editHistoryModal.visible = false"
              >Batal</base-button
            >
          </div>
        </form>
      </base-card>
    </base-modal>

    <base-modal
      :showing="downloadHistoryModal.visible"
      size="max-w-5xl"
      @close="downloadHistoryModal.visible = false"
    >
      <base-card title="Riwayat Download Data Bonus" :with-style="false">
        <datatable
          :columns="[
            { id: 'date', name: 'Tanggal' },
            { id: 'file', name: 'Nama File' },
            { id: 'user', name: 'Pengguna' },
            { id: 'download', name: 'Download' },
          ]"
          :total="downloadHistoryModal.data.meta.page.total"
          :perPage="downloadHistoryModal.data.meta.page.perPage"
          :currentPage="downloadHistoryModal.data.meta.page.currentPage"
          :meta="downloadHistoryModal.data.meta"
          @pagechanged="onDownloadHistoryPageChange"
        >
          <template #tbody="{ classes }">
            <tr
              v-for="download in downloadHistoryModal.data.data"
              :key="download.id"
              :class="classes.tr"
            >
              <td :class="classes.td">
                {{ download.attributes.createdAt | formatDate }}
              </td>
              <td :class="classes.td">{{ download.attributes.filename }}</td>
              <td :class="classes.td">{{ download.attributes.user_email }}</td>
              <td :class="classes.td">
                <a :href="download.attributes.fileurl">
                  <base-button size="sm"> Download </base-button>
                </a>
              </td>
            </tr>
          </template>
        </datatable>
      </base-card>
    </base-modal>

    <base-confirm
      icon-type="badge"
      title="Konfirmasi Reset Status Diambil"
      message="Riwayat dan Bonus yang sudah diambil akan direset statusnya menjadi belum diambil semua, lanjutkan?"
      :visible="confirmResetTaken.visible"
      @close="confirmResetTaken.visible = false"
      @confirmed="onConfirmResetTaken"
    />
  </base-wrapper>
</template>

<script>
import { requestMixin } from '@/mixins/request/request';
import { mapActions, mapGetters } from 'vuex';
import MitraPeriodSelect from '@/components/period/mitra-period/mitra-period-select.vue';
import { downloadFileUrl } from '../../../services/utils.service';
import BaseModal from '../../../components/base/BaseModal.vue';
import BaseConfirm from '../../../components/base/BaseConfirm.vue';

export default {
  mixins: [requestMixin],
  components: { MitraPeriodSelect, BaseModal, BaseConfirm },
  data() {
    return {
      bonus: {
        data: [],
        meta: {
          page: {},
          total_per_page: 0,
          total: 0,
        },
      },
      form: {
        mitraPeriodId: null,
        expectedTotalBonus: null,
        expectedTotalBonusNuera: null,
        expectedTotalOfficePoint: null,
        expectedTotalOfficeNueraPoint: null,
      },
      editHistoryModal: {
        visible: false,
        historyId: null,
        form: {
          expectedTotalBonus: null,
          expectedTotalBonusNuera: null,
          expectedTotalOfficePoint: null,
          expectedTotalOfficeNueraPoint: null,
        },
      },
      confirmResetTaken: {
        visible: false,
        historyId: null,
      },
      filterBonus: {
        mitra_period_id: null,
        office: null,
        bonus_office: null,
        keterangan: null,
        status: null,
      },
      sortBonus: [],
      histories: {
        data: [],
        meta: {
          running: false,
          page: {},
        },
      },
      loadingHistories: false,
      loadingSaveHistory: false,
      loadingResetTaken: false,
      loadingBonus: false,
      loadingSync: {
        visible: false,
        text: null,
      },
      loadingDownload: {
        visible: false,
        text: null,
      },
      downloadHistoryModal: {
        visible: false,
        loading: false,
        data: {
          data: [],
          meta: {
            page: {},
          },
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      me: 'auth/getUser',
      getChannelName: 'auth/getChannelName',
    }),
    historyColumns() {
      return [
        { id: 'date', name: 'Tanggal' },
        { id: 'period_name', name: 'Periode' },
        { id: 'user', name: 'User' },
        { id: 'total_bonus', name: 'Total Bonus' },
        { id: 'total_bonus_nuera', name: 'Total Bonus Nuera' },
        { id: 'total_office_point', name: 'Jumlah Mitra Tupo' },
        { id: 'total_office_nuera_point', name: 'Jumlah Mitra Nuera Tupo' },
        { id: 'finished_at', name: 'Selesai' },
        { id: 'bonus_status', name: 'Status Bonus', theadClass: 'text-center' },
        { id: 'status', name: 'Status', theadClass: 'text-center' },
        { id: 'taken_at', name: 'Diambil', theadClass: 'text-center' },
      ];
    },
    bonusColumns() {
      return [
        { id: 'code', name: 'Kode' },
        { id: 'temp_code', name: 'Kode Sementara' },
        { id: 'name', name: 'Nama' },
        { id: 'bonus_office', name: 'TMPBNS' },
        {
          id: 'rabat',
          name: 'Rabat',
          theadClass: 'text-right',
          sortable: true,
          sortClass: 'justify-end',
        },
        { id: 'description', name: 'Keterangan' },
        {
          id: 'taken_status',
          name: 'Status Diambil',
          theadClass: 'text-center',
        },
        {
          id: 'retrieved_status',
          name: 'Status Diterima',
          theadClass: 'text-center',
        },
      ];
    },
    sortBonusParams() {
      return this.sortBonus
        .map(
          (sortColumn) =>
            `${sortColumn.direction === 'desc' ? '-' : ''}${sortColumn.id}`
        )
        .join(',');
    },
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    addEventListener() {
      const userChannel = this.$pusher.channel(this.getChannelName);

      userChannel.bind(
        'Illuminate\\Notifications\\Events\\BroadcastNotificationCreated',
        this.onEventCreated
      );
    },
    checkHistoryNumberInValid(history) {
      if (
        history.attributes.total_bonus !==
        history.attributes.expected_total_bonus
      ) {
        return true;
      }

      if (
        history.attributes.total_bonus_nuera !==
        history.attributes.expected_total_bonus_nuera
      ) {
        return true;
      }

      if (
        history.attributes.total_office_point !==
        history.attributes.expected_total_office_point
      ) {
        return true;
      }

      if (
        history.attributes.total_office_nuera_point !==
        history.attributes.expected_total_office_nuera_point
      ) {
        return true;
      }

      return false;
    },
    getStatusText(status) {
      return {
        created: 'Sedang Diproses',
        process_bonus: 'Mengambil Data Bonus',
        process_stage: 'Mengambil Data Jenjang',
        process_carrier: 'Mengambil Data Karir',
        process_bonus_closure: 'Membuat Relasi Bonus',
        process_upline_downline_bonus_closure: 'Membuat Relasi Bonus Per Periode',
        process_network_summary: 'Membuat Ringkasan Jaringan',
        finish_network_summary: 'Menyelesaikan Ringkasan Jaringan',
        failed: 'Gagal',
        success: 'Selesai',
      }[status];
    },
    getStatusColor(status) {
      return {
        created: 'yellow',
        process_bonus: 'yellow',
        process_stage: 'yellow',
        process_carrier: 'yellow',
        process_bonus_closure: 'yellow',
        process_upline_downline_bonus_closure: 'yellow',
        process_network_summary: 'yellow',
        finish_network_summary: 'yellow',
        failed: 'red',
        success: 'green',
      }[status];
    },
    async loadHistories(params = {}) {
      this.loadingHistories = true;

      const [res, err] = await this.request('/api/v1/member-bonus-histories', {
        params: {
          'fields[member-bonus-histories]':
            'createdAt,user,expected_total_bonus,total_bonus,expected_total_bonus_nuera,total_bonus_nuera,expected_total_office_point,total_office_point,expected_total_office_nuera_point,total_office_nuera_point,period_name,finishedAt,error_message,takenAt,status',
          'page[size]': 10,
          sort: '-createdAt',
          ...params,
        },
      });

      if (err) {
        this.createAlert({
          data: 'Gagal mengambil riwayat ambil data bonus',
          status: 'error',
        });
      } else {
        this.histories = res;
      }

      this.loadingHistories = false;
    },
    async loadBonus(params = {}) {
      this.loadingBonus = true;

      const [res, err] = await this.request('/api/v1/bonus', {
        params: {
          'fields[bonus]':
            'code,temp_code,name,taken_at,retrieved_at,rabat,bonus_office,keterangan',
          'pagination[type]': 'cursor',
          'page[limit]': 5,
          'filter[mitra_period_id]': this.filterBonus.mitra_period_id,
          'filter[bonus_office]': this.filterBonus.bonus_office || null,
          'filter[code]': this.filterBonus.office || null,
          'filter[keterangan]': this.filterBonus.keterangan,
          'filter[status]': this.filterBonus.status,
          'filter[has_rabat]': true,
          sort: this.sortBonusParams,
          ...params,
        },
      });

      if (err) {
        this.createAlert({
          data: 'Gagal mengambil riwayat data bonus',
          status: 'error',
        });
      } else {
        this.bonus = res;
      }

      this.loadingBonus = false;
    },
    async loadDownloadHistory(params) {
      this.downloadHistoryModal.loading = true;
      this.downloadHistoryModal.visible = true;

      const [res, err] = await this.request('/api/v1/member-bonus-downloads', {
        params: {
          'fields[member-bonus-downloads]':
            'createdAt,filename,user_email,fileurl',
          'page[size]': 5,
          sort: '-createdAt',
          ...params,
        },
      });

      if (err) {
        this.createAlert({
          status: 'error',
          data: 'Gagal mengambil data riwayat downlaod',
        });
      } else {
        this.downloadHistoryModal.data = res;
      }

      this.downloadHistoryModal.loading = false;
    },
    onEditHistory(history) {
      this.editHistoryModal.visible = true;
      this.editHistoryModal.historyId = history.id;
      this.editHistoryModal.form.expectedTotalBonus =
        '' + history.attributes.expected_total_bonus;
      this.editHistoryModal.form.expectedTotalBonusNuera =
        '' + history.attributes.expected_total_bonus_nuera;
      this.editHistoryModal.form.expectedTotalOfficePoint =
        '' + history.attributes.expected_total_office_point;
      this.editHistoryModal.form.expectedTotalOfficeNueraPoint =
        '' + history.attributes.expected_total_office_nuera_point;
    },
    onResetTakenHistory(history) {
      this.confirmResetTaken.visible = true;
      this.confirmResetTaken.historyId = history.id;
    },
    async onSaveEditHistory() {
      this.loadingSaveHistory = true;

      const [, err] = await this.request(
        `/api/v1/member-bonus-histories/${this.editHistoryModal.historyId}`,
        {
          method: 'patch',
          data: {
            data: {
              type: 'member-bonus-histories',
              id: this.editHistoryModal.historyId,
              attributes: {
                expected_total_bonus: this.editHistoryModal.form
                  .expectedTotalBonus
                  ? +this.editHistoryModal.form.expectedTotalBonus.replace(
                      /\D/gi,
                      ''
                    )
                  : 0,
                expected_total_bonus_nuera: this.editHistoryModal.form
                  .expectedTotalBonusNuera
                  ? +this.editHistoryModal.form.expectedTotalBonusNuera.replace(
                      /\D/gi,
                      ''
                    )
                  : 0,
                expected_total_office_point: this.editHistoryModal.form
                  .expectedTotalOfficePoint
                  ? +this.editHistoryModal.form.expectedTotalOfficePoint.replace(
                      /\D/gi,
                      ''
                    )
                  : 0,
                expected_total_office_nuera_point: this.editHistoryModal.form
                  .expectedTotalOfficeNueraPoint
                  ? +this.editHistoryModal.form.expectedTotalOfficeNueraPoint.replace(
                      /\D/gi,
                      ''
                    )
                  : 0,
              },
            },
          },
        }
      );

      if (err) {
        this.createAlert({
          data: 'Gagal memperbarui riwayat data bonus',
          status: 'error',
        });
      } else {
        this.editHistoryModal.visible = false;

        this.loadHistories();
      }

      this.loadingSaveHistory = false;
    },
    async onConfirmResetTaken() {
      this.loadingResetTaken = true;

      const [, err] = await this.request(
        `/api/v1/member-bonus-histories/${this.confirmResetTaken.historyId}/-actions/reset-taken`,
        {
          method: 'patch',
        }
      );

      if (err) {
        this.createAlert({
          data: 'Gagal mereset status diambil',
          status: 'error',
        });
      } else {
        this.confirmResetTaken.visible = false;

        this.loadHistories();
      }

      this.loadingResetTaken = false;
    },
    onEventCreated(e) {
      if (e.type === 'App\\Notifications\\SyncMemberBonusDataStatusUpdated') {
        if (e.status === 'success') {
          this.stopLoadingSync();

          this.createAlert({
            data: 'Berhasil memproses data bonus',
            status: 'success',
          });

          this.loadHistories();

          this.form.expectedTotalBonus = null;
          this.form.expectedTotalBonusNuera = null;
          this.form.expectedTotalOfficePoint = null;
          this.form.expectedTotalOfficeNueraPoint = null;
          this.form.mitraPeriodId = null;

          this.filterBonus.mitra_period_id = this.me.prev_period.id;
          this.filterBonus.bonus_office = null;
          this.filterBonus.keterangan = null;
          this.filterBonus.code = null;
          this.filterBonus.status = null;

          this.loadBonus();
        } else {
          this.startLoadingSync(e.status)
        }
      } else if (e.type === 'App\\Notifications\\BonusExported') {
        if (e.status === 'failed') {
          this.stopLoadingDownload();

          this.createAlert({
            data: 'Gagal download data bonus',
            status: 'error',
          });
        } else if (e.status === 'success') {
          this.stopLoadingDownload();

          downloadFileUrl(e.file_url, 'bonus.csv', { blank: true });
        }
      }
    },
    onHistoryPageChange(page) {
      this.loadHistories({
        'page[number]': page,
      });
    },
    onBonusPageChange(page) {
      this.loadBonus(page);
    },
    onBonusSortChange(val) {
      this.sortBonus = [...val];
      this.loadBonus();
    },
    async onDownload() {
      this.startLoadingDownload('Mengirim ke server');

      const [, err] = await this.request('/api/v1/bonus/-actions/download', {
        method: 'post',
        data: {
          mitra_period_id: this.filterBonus.mitra_period_id,
          bonus_office: this.filterBonus.bonus_office
        },
      });

      if (err) {
        this.createAlert({
          data: 'Gagal download data bonus',
          status: 'error',
        });

        this.stopLoadingDownload();
      } else {
        this.loadingSync.text = 'created';
      }
    },
    async onSync() {
      this.startLoadingSync('created');

      const [, err] = await this.request(
        '/api/v1/offices/-actions/sync-member-bonus-data',
        {
          method: 'post',
          data: {
            expected_total_bonus: this.form.expectedTotalBonus
              ? this.form.expectedTotalBonus.replace(/\D/gi, '')
              : null,
            expected_total_bonus_nuera: this.form.expectedTotalBonusNuera
              ? this.form.expectedTotalBonusNuera.replace(/\D/gi, '')
              : null,
            expected_total_office_point: this.form.expectedTotalOfficePoint
              ? this.form.expectedTotalOfficePoint.replace(/\D/gi, '')
              : null,
            expected_total_office_nuera_point: this.form
              .expectedTotalOfficeNueraPoint
              ? this.form.expectedTotalOfficeNueraPoint.replace(/\D/gi, '')
              : null,
            mitra_period_id: this.form.mitraPeriodId,
          },
        }
      );

      if (err) {
        this.createAlert({
          data: 'Gagal mengambil data bonus',
          status: 'error',
        });

        this.stopLoadingSync();
      } else {
        this.loadingSync.text = 'created';
      }
    },
    async onOpenDownloadHistory() {
      this.loadDownloadHistory();
    },
    onDownloadHistoryPageChange(page) {
      this.loadDownloadHistory({
        'page[number]': page,
      });
    },
    removeEventListener() {
      const userChannel = this.$pusher.channel(this.getChannelName);

      if (userChannel) {
        userChannel.unbind(
          'Illuminate\\Notifications\\Events\\BroadcastNotificationCreated',
          this.onEventCreated
        );
      }
    },
    startLoadingSync(text) {
      this.loadingSync.text = text;
      this.loadingSync.visible = true;
    },
    stopLoadingSync() {
      this.loadingSync.visible = false;
      this.loadingSync.text = null;
    },
    startLoadingDownload(text) {
      this.loadingDownload.text = text;
      this.loadingDownload.visible = true;
    },
    stopLoadingDownload() {
      this.loadingDownload.visible = false;
      this.loadingDownload.text = null;
    },
  },
  async created() {
    this.filterBonus.mitra_period_id = this.me.prev_period.id;

    this.loadHistories().then(() => {
      if (this.histories.meta.running) {
        this.startLoadingSync('created');
      }
    });
    this.loadBonus().then(() => {
      if (this.bonus.meta.running) {
        this.startLoadingDownload('Sedang diproses');
      }
    });
    this.addEventListener();
  },
  beforeRouteLeave(to, from, next) {
    this.removeEventListener();

    next();
  },
};
</script>
